import { UtilizationSetup } from "../preAnalytical";

/**
 * Masterlist of the post-analytical supplies (band paper, ink, envelope, etc.)
 * needed by every service, per branch.
 */
export default function PostAnalyticalSetup({ readOnly = false }) {
  return <UtilizationSetup phase="postAnalytical" readOnly={readOnly} />;
}
